import { render, staticRenderFns } from "./EducationPlansView.vue?vue&type=template&id=cd53f322"
import script from "./EducationPlansView.vue?vue&type=script&lang=js"
export * from "./EducationPlansView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports